import { BrandConfig } from '../brand.config';

export const AgiSalesBrandConfig: BrandConfig = {
  appName: 'AgiSales',
  companyName: 'AgiSales Tecnologia',
  logoUrl: 'logo.png',
  favicon: 'favicon.ico',
  theme: {
    primary: '#175CD3', // blue-700 - Cor do botão principal
    secondary: '#0B8DCD', // blue-500 - Cor de feedback/info
    success: '#10B981', // green-500
    error: '#EF4444', // red-500
    warning: '#F59E0B', // yellow-500
    info: '#0B8DCD', // blue-500
    background: '#EFF8FB', // Fundo principal da aplicação
    text: '#1F2937', // gray-900
    border: '#D1D5DB', // gray-300
  },
  meta: {
    title: 'Agisales CRM',
    description: 'Sistema de gestão de propostas comerciais',
    keywords: 'gestão, propostas, vendas, crm',
  },
  menu: {
    showNotifications: true,
    notificationCount: 6,
    showUserAvatar: true,
    avatarBgColor: 'bg-blue-600',
    avatarTextColor: 'text-white',
  },
  defaultUser: {
    name: 'Carlos Silva',
    initials: 'CS',
  },
};
